
export class BulkOfferingDeckReq {
  investingEntitiesIds: number[];
  subject: string;
  message: string;
  sendAllInvestors: boolean;
}
